import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { initializeFirestore, CACHE_SIZE_UNLIMITED, enableIndexedDbPersistence, enableNetwork } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Configurar persistência de autenticação local (persiste entre navegadores)
setPersistence(auth, browserLocalPersistence)
  .then(() => {
  })
  .catch((error) => {
  });

// Inicializa Firestore com cache ilimitado para melhor performance
export const db = initializeFirestore(app, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED,
  experimentalForceLongPolling: true // Melhor compatibilidade
});

// Persistência offline: manter enableIndexedDbPersistence até que FirestoreSettings.cache seja suportado
enableIndexedDbPersistence(db, {
  forceOwnership: false
}).then(() => {
  // Persistência offline habilitada
  // Garante que a rede está habilitada
  enableNetwork(db).catch(() => {});
}).catch((err) => {
  if (err.code === 'failed-precondition') {
    // ...existing code...
  }
  // ...existing code...
});

export const googleProvider = new GoogleAuthProvider();
// Remover ou comentar a inicialização do Analytics para evitar erro offline
// export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
